export const reducer = (state, action) => {
  switch (action.type) {
    case "REFRESH":
      return {
        ...state,
        refresh: state.refresh + 1,
      };
    case "STATE":
      return {
        ...state,
        ...action.data,
      };

    case "NORM":
      return {
        ...state,
        norm: {
          ...state.norm,
          ...action.data,
        },
      };

    // Жагсаалтыг дахин татах дохио.
    //
    // ⚠ Үүнийг `{type:"STATE", data:{norm:{...state.norm, refresh: +1}}}`
    // гэж бичиж БОЛОХГҮЙ. Тэр нь handler-ийн closure дахь ХУУЧИН `state.norm`-ыг
    // бүтнээр нь буцааж бичдэг тул сая татсан шинэ `list`/`plan`-ыг дардаг —
    // «хадгалагдлаа» гэсэн ч тоо өөрчлөгдөхгүй харагдах шалтгаан нь энэ.
    // Reducer нь ҮРГЭЛЖ хамгийн сүүлийн state-ийг хүлээж авдаг тул энд
    // нэмэгдүүлэх нь хуучин утга уншихгүй.
    case "NORM_REFRESH":
      return {
        ...state,
        norm: {
          ...state.norm,
          refresh: state.norm.refresh + 1,
        },
      };

    default:
      return state;
  }
};
